










































import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import _ from "lodash";
import { DxButton } from "devextreme-vue/ui/button";
import { DxPopup } from "devextreme-vue";
import TableGrid from "@/components/TableGrid/grid.vue";
import CutHistoryService from "@/services/cut-history-service";
import CutService from "@/services/cut-service";
import UserService from "@/services/data/user_manager";
import CutHistoryDetailPopup from "@/components/Cut/cut-history-detail-popup.vue";
import base_ds from "@/services/base_datasource_service";
import { route_ns } from "@/services/cut-history-service";

@Component({
  name: "CutHistoryPopup",
  components: {
    DxButton,
    DxPopup,
    TableGrid,
    CutHistoryDetailPopup,
  },
})
export default class extends Vue {
  @PropSync("popupOptions") public localPopupOptions: any;
  @Prop() public idYear: any;

  public service = CutHistoryService;
  public cutService = CutService;
  public userService = UserService;

  public data_source = base_ds.getBaseDataSource(route_ns);

  public columns: Array<any> = [];

  public cutHistoryDetailPopup = {
    visible: false,
    title: "Лог изменений",
  };

  public action_types = [
    {
      id: 1,
      name: "Создание",
    },
    {
      id: 2,
      name: "Редактирование",
    },
    {
      id: 3,
      name: "Удаление",
    },
  ];

  async created() {
    this.data_source = base_ds.getBaseDataSource(route_ns, "id", [
      ["id_year", "=", this.idYear],
    ]);

    this.initColumns();
  }

  async mounted() {}

  async onShowing() {}

  initColumns() {
    this.columns = [
      {
        dataField: "id",
        visible: false,
      },
      {
        dataField: "date_created",
        caption: "Дата",
        sortOrder: "desc",
        dataType: "datetime",
        width: "150px",
      },
      {
        dataField: "modified_by_id",
        caption: "Пользователь",
        lookup: {
          dataSource: this.userService.userDataSource.store(),
          valueExpr: "id",
          displayExpr: "full_name",
        },
      },
      {
        dataField: "cut_name",
        caption: "Срезка",
        dataType: "string",
      },
      {
        dataField: "crud_type",
        caption: "Действие",
        dataType: "string",
        calculateCellValue: (rowData: any) => {
          const crudType = Number(rowData?.crud_type);
          const action = this.action_types.find((a: any) => Number(a.id) === crudType);
          return action ? action.name : rowData?.crud_type;
        },
      },
      {
        maxWidth: "200",
        type: "buttons",
        caption: "",
        buttons: [
          {
            icon: "comment",
            hint: "Детальный просмотр",
            onClick: this.dblRowClick,
          },
        ],
      },
    ];
  }

  onShow() {}

  rowClick(e: any) {
    this.service.setCurrent(e.data);
  }

  dblRowClick(e: any) {
    let data = e?.data;
    // Если функция вызывается из обработчика нажатия кнопки
    if (e?.row?.data) {
      data = e?.row?.data;
    }

    if (data) {
      this.service.setCurrent(data);
    }

    if (data?.crud_type === 1) {
      this.cutHistoryDetailPopup.title = "Лог создания срезки";
    } else if (data?.crud_type === 2) {
      this.cutHistoryDetailPopup.title = "Лог редактирования срезки";
    } else if (data?.crud_type === 3) {
      this.cutHistoryDetailPopup.title = "Лог удаления срезки";
    }

    this.cutHistoryDetailPopup.visible = true;
  }

  onClose() {
    this.localPopupOptions.visible = false;
  }

  empty() {}
}
